export default {
  ADD_MESSAGE: 'add_message',
  DELETE_MESSAGE: 'delete_message',
  UPDATE_MESSAGE: 'add_message',
  FETCH_MESSAGES: 'fetch_messages',
  LOAD_MORE_MESSAGES: 'load_more_messages',
};
